import { fileHelpers, usePDFActions } from "../../../../../features/files"
import { Modal, ModalId, BooleanField } from "../../../../../features/ui"
import { CustomerType } from "../../../state/types"
import { useEffect, useState } from "react"
import { CustomerTypePriceListPDF } from "../customer-type-price-list/customerTypePriceListPDF"
import { useDownloadCustomerTypeExcel } from "../download-customer-type-excel/downloadCustomerTypeExcel"
import { delay } from "../../../../../utils/codeUtils"

type Props = {
    customerType?: CustomerType
}

export const DownloadPriceListModal = ({ customerType }: Props) => {
    const [pdfName, setPdfName] = useState<string>('')
    const [excelName, setExcelName] = useState<string>('')

    const [includePDF, setIncludePDF] = useState(false)
    const [includeExcel, setIncludeExcel] = useState(false)
    const [pdfDataLoaded, setPdfDataLoaded] = useState(false)

    const { generatePDF } = usePDFActions()
    const downloadExcel = useDownloadCustomerTypeExcel()

    const pdfId = 'price-list-pdf'

    useEffect(() => {
        if (customerType) {
            setPdfName(fileHelpers.customerTypePriceListFileName(customerType.name))
            setExcelName(`Lista_de_Precios_${customerType.name.replace(/\s/g, '_')}.xlsx`)
        }
    }, [customerType])

    useEffect(() => {
        setIncludePDF(false)
        setIncludeExcel(false)
        setPdfDataLoaded(false)
    }, [customerType])

    const onSubmit = async () => {
        if (!customerType) return

        if (includePDF && pdfName) {
            generatePDF(pdfId, pdfName)
        }

        if (includePDF && includeExcel) await delay(0.5)

        if (includeExcel) {
            await downloadExcel(customerType)
        }
    }

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_CUSTOMER_TYPE_PDF}
            title="Descargar Lista de Precios"
            submitLabel={
                (includePDF && includeExcel) ? "Descargar Ambos" : "Descargar"
            }
            disableSubmit={(!includePDF && !includeExcel) || (includePDF && !pdfDataLoaded)}
            onSubmit={onSubmit}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <p>Seleccione los formatos de archivo que desea generar para <b>{customerType?.name}</b>:</p>
                
                <BooleanField 
                    id="check-pdf"
                    label={`Documento PDF (.pdf)`}
                    value={includePDF}
                    onChange={(v) => setIncludePDF(!!v)}
                />

                <BooleanField 
                    id="check-excel"
                    label={`Planilla Excel (.xlsx)`}
                    value={includeExcel}
                    onChange={(v) => setIncludeExcel(!!v)}
                />

                <div style={{ display: 'none' }}>
                    {customerType && <CustomerTypePriceListPDF id={pdfId} customerType={customerType} onLoad={() => setPdfDataLoaded(true)} />}
                </div>
            </div>
        </Modal>
    )
}